// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ab7qtIwIwXEOCRViFrYg {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.EUko8TT4FCsawHf00KAL {
  flex: 0 0;
  padding-top: 20px;
  background-color: #f7f8f9;
}
.EUko8TT4FCsawHf00KAL .ant-tabs-nav {
  margin: 0 !important;
}
.RwItJzVgg86x2SVu1egq {
  padding: 20px 0;
  flex: auto;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Item/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;AAGA;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;AADF;AAFA;EAMI,oBAAA;AADJ;AAKA;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAHF","sourcesContent":["\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.header {\n  flex: 0 0;\n  padding-top: 20px;\n  background-color: #f7f8f9;\n\n  :global .ant-tabs-nav {\n    margin: 0 !important;\n  }\n}\n\n.content {\n  padding: 20px 0;\n  flex: auto;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ab7qtIwIwXEOCRViFrYg`,
	"header": `EUko8TT4FCsawHf00KAL`,
	"content": `RwItJzVgg86x2SVu1egq`
};
export default ___CSS_LOADER_EXPORT___;
